import React, { useEffect, useState } from "react";
import { ArrowDown, Calendar, Home, Send, X } from "react-feather";
import styles from "./dashboard.module.css";
import Helmet from "react-helmet";
import Footer from "../../../components/Footer";
import { FormControl, InputLabel, MenuItem, Select, Typography, Tooltip, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import axios from "axios";
import { toast } from 'react-smart-toaster';

function LeaseRenewalDashboard() {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [tenantAllList, setTenantAllList] = useState([]);
    const [tenantList, setTenantList] = useState([]);
    const [selectedTenants, setSelectedTenants] = useState([]);
    const [filterData, setFilterData] = useState('');
    const [successModal, setSuccessModal] = useState(false);
    const [successTenants, setSuccessTenants] = useState([]);

    useEffect(() => {
        const fetchTenants = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/dashboard/tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setTenantAllList(response.data.data);
            }).catch((error) => { });
        }
        fetchTenants();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let fileredDataTemp = tenantAllList;

        if (filterData === '30 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining <= 30);
        }

        if (filterData === '60 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 30 && i?.lease_remaining <= 60);
        }

        if (filterData === '90 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 60 && i?.lease_remaining <= 90);
        }

        if (filterData === '120 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 90 && i?.lease_remaining <= 120);
        }

        console.log(filterData);

        setTenantList(fileredDataTemp);
    }, [tenantAllList, filterData]);

    const sendMessage = async () => {
        if (selectedTenants.length === 0) {
            toast.error('Please select tenant(s) first');
            return false;
        }

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/send-message', { tenant_ids: selectedTenants }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSuccessTenants(response.data.data);

            setSuccessModal(true);

            setSelectedTenants([]);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const [tenantAddOpen, setTenantAddOpen] = useState(false);

    const TenantAddFormOpen = () => {
        setTenantAddOpen(true);
    };
    const TenantAddFormClose = () => {
        setTenantAddOpen(false);
    };

    return (<>
        {loading && <Loader />}

        <Helmet title="Lease Renewal Dashboard" />

        <div className={`${styles.mainCard}`}>

            <div className={`${styles.pageTitleWrap}`}>
                <Typography display="inline" className={`${styles.pageTitle}`}>Lease Renewal Dashboard</Typography>
            </div>

            <div className={`${styles.CenterBlockSec}`}>
                <div className={`${styles.Row}`}>

                    <div className={`${styles.DahhboardHead}`}>
                        <div className={`${styles.SwitchDiv} ${styles.Select}`}>
                            <div className={`${styles.FormGroupSelect} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">All Properties*</InputLabel>
                                    <Select labelId="demo-simple-select-label" id="demo-simple-select" label="All Properties*">
                                        <MenuItem value="property1">The Westonhall</MenuItem>
                                        <MenuItem value="property2">The 42 Apartment</MenuItem>
                                        <MenuItem value="property3">Golden Joy</MenuItem>
                                        <MenuItem value="property4">30 Main St</MenuItem>
                                        <MenuItem value="property5">123 William St</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className={`${styles.FormGroupSelect} FormGroup`}>
                                <DatePicker
                                    oneTap
                                    format="MMM yyyy"
                                    placement={"bottomEnd"}
                                    caretAs={Calendar}
                                    defaultValue={new Date()}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.CashFlowSec}`}>
                        <div className={`${styles.CashFlowRow}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/Offer-Icon-1.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Offers Sent</p>
                                    <p className={`${styles.CardHeadAmount}`}>48</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/success-img.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Accepted</p>
                                    <p className={`${styles.CardHeadAmount}`}>29 <span className={`${styles.Count}`}>60%</span></p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/Offer-Icon-3.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Pending</p>
                                    <p className={`${styles.CardHeadAmount}`}>14</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/Offer-Icon-4.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Declined</p>
                                    <p className={`${styles.CardHeadAmount}`}>5</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/Offer-Icon-5.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Lease Renewal</p>
                                    <p className={`${styles.CardHeadAmount}`}>10</p>
                                </div>
                            </div>
                        </div>

                        <div className={`${styles.CashFlowRowTwo}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 30 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>8 <span className={`${styles.Text}`}>Leases</span></p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 60 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>17 <span className={`${styles.Text}`}>Leases</span></p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 90 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>26 <span className={`${styles.Text}`}>Leases</span></p>
                                </div>
                            </div>
                        </div>

                        <div className={`${styles.OfferListSec}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.OfferCardHead}`}>
                                    <div className={`${styles.OfferCardHeadTopSec}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Renewals in 30 Days <span>Next 30, 60, and 90 Days</span></p>
                                        <Link className={`${styles.AddNoteBu}`} onClick={(e) => sendMessage()}>
                                            <Send /> <span>Send Offer</span>
                                        </Link>
                                    </div>
                                    <div className={`${styles.OffersFilterBURow}`}>
                                        <button className={filterData === '' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('')}>All</button>
                                        <button className={filterData === '30 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('30 Days')}>Next 30 Days</button>
                                        <button className={filterData === '60 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('60 Days')}>31 - 60 Days</button>
                                        <button className={filterData === '90 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('90 Days')}>61 - 90 Days</button>
                                        <button className={filterData === '120 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('120 Days')}>91 - 120 Days</button>
                                    </div>
                                </div>
                                <div className={`${styles.OfferTableSec}`}>
                                    <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 220 }}>Tenant</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 180 }}>Property</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Unit</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Lease End Date</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Days Remaining</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Renewal Intent</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tenantList?.sort((a, b) => {
                                                    return a?.lease_remaining > b?.lease_remaining ? 1 : -1;
                                                })?.map((item) => {
                                                    return (<TableRow>
                                                        <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                            <Checkbox
                                                                checked={selectedTenants?.indexOf(parseInt(item?.id)) > -1}
                                                                value={item?.id}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        if (selectedTenants?.indexOf(parseInt(item?.id)) === -1)
                                                                            setSelectedTenants(prev => {
                                                                                return prev.concat([parseInt(item?.id)]);
                                                                            })
                                                                    } else {
                                                                        setSelectedTenants(prev => {
                                                                            return prev.filter(i => i !== item?.id)
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            <div className={`${styles.ProfileImg}`}><img src={item?.tenant_image} alt="" /></div>
                                                            <div className={`${styles.TenantSec}`}>
                                                                <span>{item?.tenant_name}</span>
                                                                <p>{item?.tenant_phone}</p>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.property_name}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.apt_name}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.lease_end_date}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.lease_remaining <= 30 && <span className={`${styles.StatusBadge} ${styles.Red}`}>{item?.lease_remaining} Days</span>}
                                                            {item?.lease_remaining > 30 && item?.lease_remaining <= 60 && <span className={`${styles.StatusBadge} ${styles.Yellow}`}>{item?.lease_remaining} Days</span>}
                                                            {item?.lease_remaining > 60 && <span className={`${styles.StatusBadge} ${styles.Green}`}>{item?.lease_remaining} Days</span>}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {(item?.current_status === 0 || item?.current_status === 1) && <span className={`${styles.StatusBadge}`}>-</span>}
                                                            {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Blue}`}>Offer Sent</span>}
                                                            {item?.current_status === 3 && <span className={`${styles.StatusBadge} ${styles.Purple}`}>Offer Accepted</span>}
                                                            {item?.current_status === 4 && <span className={`${styles.StatusBadge} ${styles.Yellow}`}>Unsure</span>}
                                                        </TableCell>
                                                    </TableRow>)
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <Dialog
            open={successModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setSuccessModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Messages sent successfully!
                <button onClick={(e) => setSuccessModal(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <p className="PopupBodyText">
                        Renewal offers have been sent to the selected tenants. Renewal offers have been sent to the selected tenants.
                    </p>
                    <p className={`${styles.ListTextPopup}`}>Recipients</p>
                    <ol className={`${styles.ListSecPopup}`}>
                        {successTenants?.map(i => {
                            return <li>{i}</li>
                        })}
                    </ol>
                </div>
            </DialogContent>
            <DialogActions>
                <Button className="AddPopupBU" onClick={(e) => setSuccessModal(false)}>Okay</Button>
            </DialogActions>
        </Dialog>

        <Footer />
    </>);
}

export default withAuthenticationRequired(LeaseRenewalDashboard, {
    onRedirecting: () => <Loader />,
});